import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDh24GT6FnUMpEGsBlYVWYHrxTy5hSmMOQ",
  authDomain: "nutrients-diet-app.firebaseapp.com",
  databaseURL: "https://nutrients-diet-app-default-rtdb.firebaseio.com",
  projectId: "nutrients-diet-app",
  storageBucket: "nutrients-diet-app.firebasestorage.app",
  messagingSenderId: "204687090463",
  appId: "1:204687090463:web:06d2de6df35e62c2d3462a",
  measurementId: "G-N248SSX0KW"
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export default app;
